import { useGetPrice } from 'src/hooks/usePrice'
import { ILocation } from 'src/types/graphql'
import { getCardPrice } from 'src/utils/cardPrice'

export default function useCardPrice(location: ILocation) {
  const { getPrice } = useGetPrice()
  const result = getCardPrice(location)
  const config = location.defaultConfiguration
  return {
    ...result,
    price: config ? getPrice(location, { ...config, price: result.price }) : 0
  }
}
